import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item : []
    },

    mutations: {
        facultys(state, obj) {
            state.item = obj;
        }
    },

    actions: {
        config({commit}, data) {
            return Service.facultys('exp', data, {})
                .then((response) => {
                    store.commit("faculty/facultys", response.data.data)
                    return response

                }).catch((err) => {
            });
        },
        create({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.facultys('post', {...data}, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    return store.dispatch("faculty/config", {}).then(() => response)
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },
        update({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.facultys('put', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    return store.dispatch("faculty/config", {}).then(() => response)
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },
    },

    getters: {
        facultys(state, obj) {
            return state.item;
        },
    },
};

export default ServerModule;
